'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock = require('../SkeletonBlock/SkeletonBlock.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const skeletonText = "_skeleton-text_1ht3z_1";
const styles = {
	skeletonText: skeletonText
};

const getLineHeight = (size) => ({
  heading: "var(--zds-line-height-medium, 30px)",
  body: "var(--zds-line-height-small, 15px)"
})[size];
const getLineWidth = (props, idx) => {
  if (idx === 0 && props.lines === 1) {
    return "100%";
  }
  if (idx === props.lines - 1) {
    return "70%";
  }
  if (props.textAlign === "justify") {
    return "100%";
  }
  return idx % 2 ? "100%" : "93%";
};
const SkeletonText = ({ lines, size = "body", textAlign = "left", width = "100%", color = "GrayWarm2" }) => {
  const blocks = Array.from({ length: lines }).map((_, idx) => {
    return React__default.default.createElement(components_display_SkeletonLoader_SkeletonBlock_SkeletonBlock.SkeletonBlock, { height: getLineHeight(size), key: idx, width: getLineWidth({ lines, textAlign }, idx), color });
  });
  const style = {
    width
  };
  return React__default.default.createElement("div", { className: styles.skeletonText, "data-testid": "SkeletonText", "data-zds": true, "data-text-align": textAlign, style }, blocks);
};

exports.SkeletonText = SkeletonText;
//# sourceMappingURL=SkeletonText.cjs.js.map
